import {
  Alert,
  Autocomplete,
  Button,
  InputAdornment,
  TextField,
} from "@mui/material";
import { Box, Grid, Stack } from "@mui/system";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import UploadIcon from "@mui/icons-material/Upload";
import DevObjectsFilterItems from "./DevObjectsFilterItems";
import { FilterOption } from "../Configs/ConfigsFilterItems";

interface Props {
  /** distinct field_type values, deduped by the owning tab */
  searchOptions: string[];
  selectedFieldType: string | null;
  onSelectFieldType: (value: string | null) => void;
  objectTypeOptions: FilterOption[];
  selectedObjectTypes: string[];
  onSelectedObjectTypesChange: (value: string[]) => void;
  onClearFilters: () => void;
  canCreate: boolean;
  onCreate: () => void;
  onImportCsv: () => void;
}

/** The explanation, search box, filters and actions above the Dev Objects table. */
const DevObjectsFilterCard = ({
  searchOptions,
  selectedFieldType,
  onSelectFieldType,
  canCreate,
  onCreate,
  onImportCsv,
  ...filterItemProps
}: Props) => (
  <Box sx={{ padding: "16px 16px 8px" }}>
    <Alert severity="info" sx={{ mb: 2 }}>
      <b>Dev Objects</b> — every <code>objects</code> row whose{" "}
      <code>object_type</code> is not one of the four collection levels
      (interface_id, report_id, brand_id, raw_output_table_name). That means the
      system-default globals the collector falls back to when nothing narrower
      sets a key, plus any row written with a malformed level. One row at a
      time, saved immediately.
    </Alert>

    <Grid container rowSpacing={2} columnSpacing={3} alignItems="center">
      <Grid size={3}>
        <Autocomplete
          data-tracker="1145"
          sx={{ width: "100%" }}
          options={searchOptions}
          value={selectedFieldType}
          onChange={(_, newValue) => onSelectFieldType(newValue)}
          renderInput={(params) => (
            <TextField
              {...params}
              label="field_type"
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ marginLeft: "12px" }} />
                  </InputAdornment>
                ),
              }}
              color="secondary"
            />
          )}
          size="small"
        />
      </Grid>
      <Grid size={5}>
        <DevObjectsFilterItems {...filterItemProps} />
      </Grid>
      <Grid size={4}>
        <Stack direction="row" spacing={1} justifyContent="flex-end">
          {canCreate && (
            <>
              <Button
                color="secondary"
                startIcon={<UploadIcon />}
                sx={{ whiteSpace: "nowrap" }}
                onClick={onImportCsv}
                disabled
              >
                Import CSV
              </Button>
              <Button
                variant="contained"
                color="secondary"
                sx={{ whiteSpace: "nowrap" }}
                onClick={onCreate}
                disabled
              >
                Create new Object <AddIcon sx={{ width: "20px", ml: "5px" }} />
              </Button>
            </>
          )}
        </Stack>
      </Grid>
    </Grid>
  </Box>
);

export default DevObjectsFilterCard;
